import React from 'react';
import AuthService from './authService.js';

class WaveService extends React.Component {
  static GetWaveList(waveId, clientId) {
    const authService = AuthService.getInstance();

    let url = '/api/Wave';

    if (waveId != null && waveId !== -1) {
      url += `/${waveId}?clearCache=false`;
    } else if (clientId != null && clientId !== -1) {
      url += `?clientId=${clientId}&clearCache=false`;
    }

    return authService.CallBackendFunction(url);
  }
}

export default WaveService;
